
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Ertigacabbookinginpune() {



    const cardData =
    {
        keyword: ' Ertiga Cab Booking in Pune',
        heading: 'Prince Cabs: Ertiga Cab Booking in Pune',
        headingDescription: 'Prince Cabs offers convenient Ertiga Cab Booking in Pune, perfect for family trips, corporate travel, airport transfers, and outstation journeys. Our spacious and well-maintained Ertiga vehicles are equipped with modern features to provide a safe, comfortable, and enjoyable travel experience. With professional chauffeurs, transparent pricing, and flexible booking options, we make your journey hassle-free and reliable. Choose Prince Cabs’ trusted Ertiga cab booking service in Pune for affordability, comfort, and peace of mind..',

        top: 'Top Places to Visit in Pune with Prince Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732, was the majestic seat of the Peshwas of the Maratha Empire. Its grand stone walls, massive gates, and sprawling courtyards narrate tales of bravery and politics. Though partially destroyed by fire in 1828, its ruins still showcase Pune’s glorious past. The evening light-and-sound show recreates Maratha history with drama and pride. Visitors enjoy exploring the gardens and old fortifications. Shaniwar Wada remains Pune’s most iconic landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is one of Pune’s most treasured monuments. During the Quit India Movement, Mahatma Gandhi and Kasturba Gandhi were imprisoned here. Today, the palace houses a museum with photographs, letters, and personal artifacts of Gandhi. Its vast lawns provide a peaceful retreat for visitors. The monument is recognized as a national heritage site. It is a timeless symbol of sacrifice and patriotism."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, about 30 km from Pune, is known for the 1670 battle where Tanaji Malusare fought bravely for the Marathas. The fort’s ruins, bastions, and watchtowers offer glimpses into history. Trekkers love the scenic climb, especially during monsoon when the hills turn lush green. From the top, views of the Sahyadri ranges are breathtaking. Local vendors serve traditional pithla-bhakri, enhancing the experience. Sinhagad is a mix of history, adventure, and nature."
  },
  {
    "title": "Dagdusheth Halwai Ganapati Temple",
    "description": "The Dagdusheth Halwai Ganapati Temple is Pune’s most famous religious site, dedicated to Lord Ganesha. The idol, adorned with gold ornaments, attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of cultural celebrations. It is also known for its charitable contributions and social work. Its central location makes it easily accessible for locals and tourists. It is both a spiritual and cultural icon of Pune."
  },
  {
    "title": "Parvati Hill",
    "description": "Parvati Hill is one of Pune’s highest points, offering sweeping views of the city. At the summit lies the Parvati Temple complex, dedicated to Lord Shiva and Goddess Parvati. Visitors climb over 100 steps to reach this spiritual and historical site. The Peshwa Museum nearby displays Maratha-era artifacts. Sunrises and sunsets from the hill are especially enchanting. Parvati Hill blends devotion, heritage, and natural beauty."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, Pataleshwar Cave Temple is a rock-cut shrine dedicated to Lord Shiva. It features massive stone pillars, a sanctum with a Shiva linga, and a stone-carved Nandi. Despite being in the city center, it offers a calm and meditative environment. The temple reflects Rashtrakuta-era architectural brilliance. Visitors admire its historical and spiritual charm. It is one of Pune’s hidden heritage gems."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum showcases over 20,000 artifacts collected by Dr. Dinkar Kelkar. Its exhibits include sculptures, paintings, musical instruments, and everyday objects from across India. A highlight is the recreated Mastani Mahal, reflecting Maratha history. The museum fascinates both art lovers and history buffs. It reflects the cultural richness of Maharashtra. This museum is one of Pune’s most unique attractions."
  },
  {
    "title": "Osho Ashram (Koregaon Park)",
    "description": "The Osho International Meditation Resort in Koregaon Park is a global retreat for wellness and spirituality. Visitors from across the world come here for meditation, yoga, and therapy programs. Surrounded by serene gardens and modern architecture, it offers peace and relaxation. The ashram promotes holistic growth and mindfulness. Its vibrant international community adds cosmopolitan flavor. It is a unique blend of spirituality and lifestyle."
  },
  {
    "title": "Phoenix Marketcity",
    "description": "Phoenix Marketcity in Viman Nagar is Pune’s largest shopping and lifestyle destination. It houses global and Indian retail brands, multiplex cinemas, and entertainment zones. The mall also offers gourmet dining experiences and seasonal events. Families love it for a complete day of shopping and leisure. It represents the modern and urban side of Pune. Phoenix Marketcity is the city’s ultimate retail hub."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, about 20 km from Pune, is a favorite picnic and weekend spot. It provides water to the city and is surrounded by scenic hills. Families enjoy street food, boating, and evening walks here. The monsoon season transforms it into a lush paradise with misty views. Cool breezes make evenings refreshing by the waterside. Khadakwasla is Pune’s peaceful natural retreat."
  },
  {
    "title": "Mulshi Lake",
    "description": "Mulshi Lake, formed by the Mulshi Dam, is a serene destination near Pune. Surrounded by forests, waterfalls, and Sahyadri hills, it is perfect for camping and photography. Monsoon enhances its beauty with greenery and mist. Eco-resorts nearby offer a cozy stay for families and couples. Trekkers also love its trails and scenic landscapes. Mulshi is an ideal spot for nature and relaxation."
  },
  {
    "title": "Chaturshringi Temple",
    "description": "Chaturshringi Temple, on Senapati Bapat Road, is one of Pune’s oldest shrines dedicated to Goddess Chaturshringi. Devotees climb more than 100 steps to reach the sanctum. The temple is vibrant during Navratri with cultural and religious festivities. Thousands of pilgrims visit to seek blessings year-round. Its hilltop setting offers panoramic city views. It is both a spiritual and cultural landmark."
  },
  {
    "title": "National War Memorial Southern Command",
    "description": "The National War Memorial in Pune honors soldiers who sacrificed their lives post-independence. It displays tanks, weapons, and war memorabilia. A museum inside narrates stories of India’s military history. The evening flag retreat ceremony is deeply moving. Families and students visit to pay respects and learn patriotism. It is a place of pride and remembrance for the armed forces."
  },
  {
    "title": "Empress Garden",
    "description": "Empress Garden, spread across 39 acres, is a botanical park with exotic plants and shaded walkways. Managed by the Agri-Horticultural Society, it is one of Pune’s oldest gardens. Families visit for picnics, leisure walks, and relaxation. The annual flower show is a major attraction for nature lovers. Its colonial heritage adds historical charm. Empress Garden is a peaceful green escape within the city."
  },
  {
    "title": "Vetal Tekdi (Vetal Hill)",
    "description": "Vetal Tekdi, the highest hill in Pune, is a favorite among joggers, cyclists, and nature lovers. The hilltop offers sweeping views of the entire city. It is rich in biodiversity, with birds and native flora adding to its charm. Sunrises and sunsets from here are especially captivating. Locals come for morning yoga and fitness activities. Vetal Hill is Pune’s natural lung and a serene retreat."
  }
],

"services": [
  {
    "name": "Ertiga on Rent Pune",
    "description": "Rent Ertiga cars in Pune for a spacious and comfortable ride. Perfect for family outings, corporate travel, and city commutes, our Ertiga rentals come with professional drivers and well-maintained vehicles to ensure a smooth journey."
  },
  {
    "name": "Book Ertiga for Outstation Pune",
    "description": "Plan your outstation trips with our reliable Ertiga cab service from Pune. Ideal for long-distance travel to nearby cities and tourist spots, offering ample space, comfort, and safety throughout the journey."
  },
  {
    "name": "Ertiga for Pune to Mumbai",
    "description": "Travel from Pune to Mumbai in a comfortable Ertiga cab that provides a smooth and safe ride. Whether for business or leisure, enjoy professional service and timely pickups on this popular route."
  },
  {
    "name": "Ertiga Cab for Family Trip Pune",
    "description": "Make your family trips memorable with our spacious Ertiga cabs in Pune. Comfortable seating and courteous drivers ensure an enjoyable travel experience for families of all sizes."
  },
  {
    "name": "Ertiga for Pune to Goa Tour",
    "description": "Explore the scenic route from Pune to Goa in an Ertiga taxi, perfect for group travel with plenty of luggage space and comfortable seating, ensuring a relaxed and enjoyable journey."
  },
  {
    "name": "Ertiga Crysta Rental Pune",
    "description": "Experience premium travel with Ertiga Crysta rentals in Pune. Ideal for corporate clients and travelers who prefer extra comfort, space, and a high-end vehicle for their trips."
  },
  {
    "name": "Pune to Mahabaleshwar Ertiga Booking",
    "description": "Book Ertiga cabs for your trips from Pune to the picturesque hill station of Mahabaleshwar. Enjoy a smooth and comfortable ride suitable for groups and families looking to escape the city."
  },
  {
    "name": "Ertiga Taxi Service in Hinjewadi",
    "description": "Avail Ertiga taxi services in the Hinjewadi area, suitable for office commutes, local travel, and outstation journeys with prompt pickups and reliable service."
  },
  {
    "name": "Ertiga on Rent Kharadi",
    "description": "Rent Ertiga cars in Kharadi for daily travel, weekend getaways, or business trips. Our service ensures well-maintained vehicles and professional drivers for a hassle-free experience."
  },
  {
    "name": "Ertiga Cab for Wedding Pune",
    "description": "Make your wedding transportation seamless with Ertiga cab rentals in Pune. Spacious interiors and courteous chauffeurs provide a dignified and comfortable travel experience on your special day."
  },
  {
    "name": "Ertiga for Local Travel in Pune",
    "description": "Choose Ertiga cabs for your local travel needs within Pune. Whether it’s airport transfers, shopping trips, or daily commutes, enjoy reliable service and comfortable rides."
  },
  {
    "name": "AC Ertiga Cab Hire Pune",
    "description": "Stay cool and comfortable during your journeys in Pune with our air-conditioned Ertiga cab rentals, perfect for both local and outstation trips."
  },
  {
    "name": "Ertiga for Corporate Trips Pune",
    "description": "Professional and timely Ertiga taxi services for corporate clients in Pune, ensuring comfort and punctuality for business meetings, conferences, and client visits."
  },
  {
    "name": "7 Seater Ertiga Taxi Pune",
    "description": "Book 7 seater Ertiga taxis in Pune for group travel, family outings, or office commutes. Spacious seating and reliable service make it an ideal choice for comfortable transport."
  },
  {
    "name": "Affordable Ertiga Cab Pune",
    "description": "Get affordable Ertiga cab rental options in Pune without compromising on safety and comfort. Perfect for budget-conscious travelers looking for quality service."
  }
],
"tableData": [
  ["Ertiga on Rent Pune", "Book Ertiga for Outstation Pune"],
  ["Ertiga for Pune to Mumbai", "Ertiga Cab for Family Trip Pune"],
  ["Ertiga for Pune to Goa Tour", "Ertiga Crysta Rental Pune"],
  ["Pune to Mahabaleshwar Ertiga Booking", "Ertiga Taxi Service in Hinjewadi"],
  ["Ertiga on Rent Kharadi", "Ertiga Cab for Wedding Pune"],
  ["Ertiga for Local Travel in Pune", "AC Ertiga Cab Hire Pune"],
  ["Ertiga for Corporate Trips Pune", "7 Seater Ertiga Taxi Pune"],
  ["Affordable Ertiga Cab Pune"]
],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Ertiga Cab Booking Service in Pune",
    "WhyChoosedescription": "Prince Cabs offers dependable and comfortable Ertiga cab services in Pune, perfect for families, groups, and business travelers. Our booking service ensures a smooth, safe, and timely journey across Pune and to nearby destinations, providing you with a spacious and reliable vehicle whenever you need it."
  },
  {
    "WhyChooseheading": "Well-Maintained and Spacious Ertiga Vehicles",
    "WhyChoosedescription": "Our Ertiga cabs are regularly serviced and maintained to provide a comfortable and smooth ride. With ample seating for 7 passengers, generous legroom, and sufficient luggage space, the Ertiga is ideal for group travel, airport transfers, and long-distance trips."
  },
  {
    "WhyChooseheading": "Flexible Booking Options to Suit Your Schedule",
    "WhyChoosedescription": "Booking your Ertiga cab is easy with Prince Cabs. Choose from hourly rentals, full-day bookings, or outstation trips. We offer flexible cancellation and rescheduling policies to accommodate your changing plans, with instant confirmation through phone, WhatsApp, or online bookings."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Local Route Knowledge",
    "WhyChoosedescription": "Our professional drivers are well-acquainted with Pune’s routes and traffic patterns, ensuring safe, efficient, and timely travel. They assist with luggage and provide courteous service, making your journey pleasant and stress-free."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Fees",
    "WhyChoosedescription": "Our pricing for Ertiga cab bookings in Pune is clear and competitive, inclusive of fuel, tolls, taxes, and driver allowances. We accept multiple payment options such as UPI, credit/debit cards, net banking, and cash, ensuring convenience and transparency."
  },
  {
    "WhyChooseheading": "Sanitized and Well-Maintained Vehicles for Your Safety",
    "WhyChoosedescription": "Each Ertiga cab undergoes thorough cleaning and sanitization before every trip. Equipped with safety features like seat belts and airbags, our vehicles offer a secure and hygienic environment for all passengers."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for a Hassle-Free Experience",
    "WhyChoosedescription": "Our dedicated customer support team is available around the clock to assist you with bookings, itinerary changes, and any travel-related queries, ensuring your Ertiga cab experience in Pune is smooth and worry-free."
  }
]






























    }

const faqData = [
    {
        question: 'Can I book an Ertiga cab in Pune through Prince Cabs?',
        answer: 'Yes, Prince Cabs offers Ertiga cab bookings in Pune for local travel, airport transfers, and outstation trips.',
    },
    {
        question: 'What types of trips can I book with an Ertiga cab?',
        answer: 'You can book Ertiga cabs for hourly local rides, full-day rentals, and outstation trips including one-way and round trips.',
    },
    {
        question: 'Are the Ertiga cabs well-maintained and sanitized?',
        answer: 'Absolutely! All Ertiga vehicles are regularly serviced, cleaned, and sanitized to ensure passenger safety and comfort.',
    },
    {
        question: 'Does the Ertiga cab come with a driver?',
        answer: 'Yes, all Ertiga cab bookings include a professional and courteous driver to provide a hassle-free travel experience.',
    },
    {
        question: 'What is the fare for booking an Ertiga cab in Pune?',
        answer: 'Fares depend on the trip type and duration. Please contact Prince Cabs for a personalized and competitive quote.',
    },
    {
        question: 'How do I book an Ertiga cab in Pune?',
        answer: 'You can book easily through our website or by calling our customer support team for quick confirmation.',
    },
    {
        question: 'Are there any special packages for Ertiga cab bookings?',
        answer: 'Yes, Prince Cabs offers special packages for corporate travel, airport transfers, and long-distance journeys with Ertiga cabs.',
    },
];

const testimonials = [
    {
        name: "Mr. Rohit Kulkarni",
        position: "Business Traveler",
        text: "Booking an Ertiga cab from Prince Cabs in Pune was smooth and convenient. The vehicle was spacious and comfortable.",
        image: "/img/testimonial/testimonial-thumb-ertiga-pune-1.png",
    },
    {
        name: "Ms. Priya Singh",
        position: "Family Traveler",
        text: "The Ertiga cab service from Prince Cabs made our Pune trip comfortable and hassle-free. Highly recommended!",
        image: "/img/testimonial/testimonial-thumb-ertiga-pune-2.png",
    },
];












































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Ertiga Cab Booking in Pune",
  "description": "Book Ertiga cabs in Pune for outstation trips, family travel, weddings, corporate trips, and local travel. Affordable 7-seater Ertiga rental available in Hinjewadi, Kharadi, and across Pune.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Prince Cabs",
    "telephone": "+91-XXXXXXXXXX",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "addressCountry": "IN"
    }
  },
  "serviceType": [
    "Ertiga on Rent Pune",
    "Book Ertiga for Outstation Pune",
    "Ertiga for Pune to Mumbai",
    "Ertiga Cab for Family Trip Pune",
    "Ertiga for Pune to Goa Tour",
    "Ertiga Crysta Rental Pune",
    "Pune to Mahabaleshwar Ertiga Booking",
    "Ertiga Taxi Service in Hinjewadi",
    "Ertiga on Rent Kharadi",
    "Ertiga Cab for Wedding Pune",
    "Ertiga for Local Travel in Pune",
    "AC Ertiga Cab Hire Pune",
    "Ertiga for Corporate Trips Pune",
    "7 Seater Ertiga Taxi Pune",
    "Affordable Ertiga Cab Pune"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  }
};






    return (
        <div>
<Helmet>
  <title>Ertiga Cab Booking in Pune | Affordable 7 Seater Ertiga Rental</title>
  <meta
    name="description"
    content="Book Ertiga cabs in Pune for outstation, family trips, weddings, corporate travel, and local use. Affordable 7-seater Ertiga rental available in Hinjewadi, Kharadi, and Pune."
  />
  <meta
    name="keywords"
    content="Ertiga on Rent Pune, Book Ertiga for Outstation Pune, Ertiga for Pune to Mumbai, Ertiga Cab for Family Trip Pune, Ertiga for Pune to Goa Tour, Ertiga Crysta Rental Pune, Pune to Mahabaleshwar Ertiga Booking, Ertiga Taxi Service in Hinjewadi, Ertiga on Rent Kharadi, Ertiga Cab for Wedding Pune, Ertiga for Local Travel in Pune, AC Ertiga Cab Hire Pune, Ertiga for Corporate Trips Pune, 7 Seater Ertiga Taxi Pune, Affordable Ertiga Cab Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/69.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Ertigacabbookinginpune ;